import { Box, BoxProps } from "@chakra-ui/react";

export function PinColorIcon({ ...props }: BoxProps) {
  return (
    <Box cursor={"pointer"} {...props}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.75 12.2487L4.66667 9.33203"
          stroke="#1819B4"
          stroke-width="0.875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.73406 11.0083C5.55047 10.5125 3.48738 8.44945 2.9916 6.26588C2.91312 5.92021 2.87388 5.74738 2.98756 5.46698C3.10125 5.18658 3.24012 5.09982 3.51787 4.9263C4.14574 4.53405 4.82561 4.40935 5.53118 4.47175C6.52122 4.55932 7.01624 4.6031 7.26318 4.47444C7.51012 4.34578 7.67793 4.04493 8.01355 3.44323L8.4387 2.68102C8.71876 2.17891 8.8588 1.92786 9.1882 1.80951C9.51761 1.69116 9.71584 1.76283 10.1123 1.90617C11.0395 2.24137 11.7586 2.96044 12.0938 3.88762C12.2371 4.2841 12.3088 4.48234 12.1905 4.81174C12.0721 5.14115 11.821 5.28118 11.3189 5.56125L10.5391 5.99619C9.93858 6.33117 9.6383 6.49866 9.50969 6.74801C9.38107 6.99737 9.42778 7.48161 9.52121 8.4501C9.58991 9.16229 9.4715 9.84666 9.07398 10.4823C8.90029 10.76 8.81344 10.8989 8.53312 11.0125C8.2528 11.1261 8.07988 11.0868 7.73406 11.0083Z"
          fill="#1819B4"
          stroke="#1819B4"
          stroke-width="0.875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}
